if (!customElements.get('hero-image-slider')) {
  customElements.define(
    'hero-image-slider',
    class HeroImageSlider extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.hero-image-slider__track');
        this.slides = Array.from(this.querySelectorAll('.hero-image-slider__slide'));
        this.dots = Array.from(this.querySelectorAll('.hero-image-slider__dot'));
        this.current = 0;
        if (!this.track || this.slides.length < 2) return;

        this.querySelector('[name="previous"]')?.addEventListener('click', () => this.goTo(this.current - 1));
        this.querySelector('[name="next"]')?.addEventListener('click', () => this.goTo(this.current + 1));
        this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.goTo(index)));

        this.track.addEventListener('scroll', () => {
          window.cancelAnimationFrame(this.scrollFrame);
          this.scrollFrame = window.requestAnimationFrame(() => this.onScroll());
        });

        this.autoplay = this.dataset.autoplay === 'true';
        this.speed = (parseInt(this.dataset.speed, 10) || 5) * 1000;
        if (this.autoplay && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          ['mouseenter', 'focusin', 'touchstart'].forEach((event) =>
            this.addEventListener(event, () => this.stop(), { passive: true })
          );
          ['mouseleave', 'focusout'].forEach((event) => this.addEventListener(event, () => this.play()));
          this.play();
        }

        // Theme editor: show the selected block
        if (window.Shopify?.designMode) {
          document.addEventListener('shopify:block:select', (event) => {
            const index = this.slides.indexOf(event.target);
            if (index === -1) return;
            this.stop();
            this.goTo(index, false);
          });
          document.addEventListener('shopify:block:deselect', () => this.play());
        }
      }

      disconnectedCallback() {
        this.stop();
      }

      goTo(index, smooth = true) {
        const count = this.slides.length;
        this.current = (index + count) % count;
        this.track.scrollTo({
          left: this.current * this.track.clientWidth,
          behavior: smooth ? 'smooth' : 'auto',
        });
        this.updateDots();
      }

      onScroll() {
        const index = Math.round(this.track.scrollLeft / this.track.clientWidth);
        if (index !== this.current && this.slides[index]) {
          this.current = index;
          this.updateDots();
        }
      }

      updateDots() {
        this.dots.forEach((dot, index) => {
          const active = index === this.current;
          dot.classList.toggle('is-active', active);
          active ? dot.setAttribute('aria-current', 'true') : dot.removeAttribute('aria-current');
        });
      }

      play() {
        if (!this.autoplay) return;
        this.stop();
        this.timer = window.setInterval(() => this.goTo(this.current + 1), this.speed);
      }

      stop() {
        window.clearInterval(this.timer);
      }
    }
  );
}
